import chalk from "chalk";
import { getSvgDir } from "../utils/package-root";
import { getAllIcons } from "../utils/svg-parser";

type ListOptions = {
  filter?: string;
};

export async function listCommand(options: ListOptions): Promise<void> {
  try {
    // Determine SVG directory from submodule
    const svgDir = getSvgDir(import.meta.url);

    // Get all icons
    let icons = await getAllIcons(svgDir);

    // Apply filter if provided
    if (options.filter) {
      const filterLower = options.filter.toLowerCase();
      icons = icons.filter((icon) => icon.toLowerCase().includes(filterLower));
    }

    if (icons.length === 0) {
      if (options.filter) {
        console.log(
          chalk.yellow(`No icons found matching '${options.filter}'`),
        );
      } else {
        console.log(chalk.yellow("No icons found"));
      }
      return;
    }

    // Display icons in columns
    const columns = process.stdout.columns || 80;
    const columnWidth = 25;
    const numColumns = Math.floor(columns / columnWidth);

    console.log(chalk.cyan.bold("\nAvailable Icons:\n"));

    for (let i = 0; i < icons.length; i += numColumns) {
      const row = icons.slice(i, i + numColumns);
      const formattedRow = row.map((icon) => icon.padEnd(columnWidth)).join("");
      console.log(chalk.white(formattedRow));
    }

    // Display count
    const countMessage = options.filter
      ? `\nFound ${chalk.bold(icons.length)} icons matching '${options.filter}'`
      : `\nTotal: ${chalk.bold(icons.length)} icons`;

    console.log(chalk.cyan(countMessage));
  } catch (error) {
    console.error(chalk.red("Error listing icons:"), (error as Error).message);
    process.exit(1);
  }
}
